import * as THREE from 'three';

/**
 * Pixelate Shader
 * Creates a retro pixel art effect on the photosphere
 */
export const PixelateShader = {
    name: 'PixelateShader',

    uniforms: {
        tDiffuse: { value: null },
        resolution: { value: new THREE.Vector2(1920, 1080) },
        pixelSize: { value: 12.0 },
        gamma: { value: 0.5 },

    },

    vertexShader: /* glsl */ `
        varying vec2 vUv;

        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,

    fragmentShader: /* glsl */ `
        uniform sampler2D tDiffuse;
        uniform vec2 resolution;
        uniform float pixelSize;
        uniform float gamma;

        varying vec2 vUv;

        void main() {
            vec2 dxy = pixelSize / resolution;
            vec2 coord = dxy * floor(vUv / dxy);
            vec4 color = texture2D(tDiffuse, coord);
            color.rgb = pow(color.rgb, vec3(gamma));
            gl_FragColor = color;
        }
    `,
};

/**
 * Creates uniforms for the pixelate shader with custom settings
 */
export function createPixelateUniforms(
    pixelSize: number = 8.0,
    resolution: THREE.Vector2 = new THREE.Vector2(1920, 1080),
    brightness: number = 2
): Record<string, THREE.IUniform> {
    return {
        tDiffuse: { value: null },
        resolution: { value: resolution.clone() },
        pixelSize: { value: pixelSize },
        brightness: { value: brightness },
    };
}
